import React from 'react'

import { getAdStatus } from './ad-status'

import {
    Table, 
    Badge,
    Tag
} from 'antd'

class ApprovedTable extends React.Component {
    render(){

        const columns = [{
            title: 'Name',
            dataIndex: 'name'
        },{
            title: 'Status',
            dataIndex: 'status',
            render: (status) => {
                return <Badge
                    style={{
                        whiteSpace: 'nowrap'
                    }}
                    text={status}
                    status={getAdStatus(status)}
                />
            }
        },{
            title: 'Billing Status',
            dataIndex: 'stripe.status',
            render: (status) => {
                return (
                    <Tag>
                        {status.toUpperCase()}
                    </Tag>
                )
            }
        },{
            title: "User",
            dataIndex: 'user',
            render: (user) => {
                return (
                    <div>
                        <div>
                            {user.local.email}
                        </div>
                        <div>
                            {user.details.name}
                        </div>
                        <div>
                            {user.details.companyName}
                        </div>
                    </div>
                )
            } 
        },{
            title: "Actions",
            dataIndex: '_id',
            render: (adId) => {
                return (
                    <a 
                    target="_blank"
                    href={`/eezee-ads/${adId}`}>
                        Review
                    </a>
                )
            }
        }]

        return(
            <Table
                loading={this.props.loading}
                columns={columns}
                dataSource={this.props.data}
            />
        )
    }
}

export default ApprovedTable


// WEBPACK FOOTER //
// ./src/components/eezee-ads/table/approved.js